// extracted by mini-css-extract-plugin
export default {"background":"BannerCarousel_background__P3D5z"};